import React, {useEffect, useState} from 'react';
import axios from "axios";

export default function CreateProductModal({ onClose, onUpdateScreen }) {

    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]); // Estado para armazenar as categorias

    const [formData, setFormData] = useState({
        nome: '',
        valor: '',
        descricao: '',
        quantidade: '',
        categoria: '',
        valor_venda: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        nome: '',
        valor: '',
        descricao: '',
        quantidade: '',
        categoria: '',
        valor_venda: '',
    });

    // Função para carregar as categorias
    const loadCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/categoryRoutes/category`);
            setCategories(response.data);
        } catch (error) {
            console.error('Erro ao carregar as categorias', error);
        }

    };

    useEffect(() => {
        loadCategories();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateForm = () => {
        let isValid = true;
        let newErrorMessages = {
            nome: '', valor: '', descricao: '', quantidade: '', categoria: ''
        };

        if (!formData.nome.trim()) {
            newErrorMessages.nome = 'O nome do produto é obrigatório.';
            isValid = false;
        }

        if (!formData.valor.trim()) {
            newErrorMessages.valor = 'O valor é obrigatório.';
            isValid = false;
        } else if (isNaN(formData.valor) || formData.valor <= 0) {
            newErrorMessages.valor = 'O valor deve ser um número válido e maior que 0.';
            isValid = false;
        }

        if (!formData.quantidade.trim()) {
            newErrorMessages.quantidade = 'A quantidade é obrigatória.';
            isValid = false;
        } else if (isNaN(formData.quantidade) || formData.quantidade < 0 || !Number.isInteger(Number(formData.quantidade))) {
            newErrorMessages.quantidade = 'A quantidade deve ser um número inteiro válido e maior ou igual a 0.';
            isValid = false;
        }

        if (!formData.categoria.trim()) {
            newErrorMessages.categoria = 'A categoria é obrigatória.';
            isValid = false;
        }

        setErrorMessages(newErrorMessages);
        return isValid;
    };

    const formatarNome = (nome) => {
        return nome
            .split(' ')
            .map((parte) => parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase())
            .join(' ');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            try {
                setLoading(true);

                const productData = {
                    ...formData,
                    nome: formatarNome(formData.nome),  // Nome com as primeiras letras maiúsculas
                };

                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product`, productData, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                if (response.status === 201) {
                    onUpdateScreen();
                    onClose(); // Fecha o modal
                } else {
                    alert('Ocorreu um erro ao tentar cadastrar o produto.');
                }

            } catch (error) {
                console.error('Erro ao criar produto:', error);
                alert('Não foi possível criar o produto. Tente novamente mais tarde.');
            } finally {
                setLoading(false);
            }

            onClose(); // Fechar o modal após o cadastro bem-sucedido
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-90">
            <div className="glass-panel p-6 w-full max-w-2xl text-white w-300">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Cadastrar Novo Produto</h2>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-200">Nome</label>
                            <input
                                type="text"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.nome ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.nome && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.nome}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Valor</label>
                            <input
                                type="float"
                                name="valor"
                                value={formData.valor}
                                onChange={handleChange}
                                min="0"
                                className={`glass-input w-full ${errorMessages.valor ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.valor && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.valor}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Valor de Venda</label>
                            <input
                                type="float"
                                name="valor_venda"
                                value={formData.valor_venda}
                                onChange={handleChange}
                                min="0"
                                className={`glass-input w-full ${errorMessages.valor_venda ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.valor_venda && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.valor_venda}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Quantidade</label>
                            <input
                                type="number"
                                name="quantidade"
                                value={formData.quantidade}
                                onChange={handleChange}
                                min="0"
                                className={`glass-input w-full ${errorMessages.quantidade ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.quantidade && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.quantidade}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Categoria</label>
                            <select
                                name="categoria"
                                value={formData.categoria}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.categoria ? 'border-red-500' : ''}`}
                            >
                                <option value="">Selecione uma categoria</option>
                                {categories.map((category) => (
                                    <option key={category.id} value={category.nome}>
                                        {category.nome}
                                    </option>
                                ))}
                            </select>
                            {errorMessages.categoria && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.categoria}</p>
                            )}
                        </div>

                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-200 space-x-2">Descrição</label>
                        <textarea
                            name="descricao"
                            value={formData.descricao}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.descricao ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.descricao && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.descricao}</p>
                        )}
                    </div>

                    <div className="flex justify-end space-x-2 mt-10">
                        <button
                            type="button"
                            onClick={onClose}
                            className="glass-button bg-red-500/20 hover:bg-red-500/40 text-red-400"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="glass-button bg-green-500/20 hover:bg-green-500/40 text-green-400"
                        >
                            Cadastrar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
